/**
 * PublicationListItemCategory
 */
import React from 'react';
/** Publication list category. */
var PublicationListItemCategory = function (_a) {
    var text = _a.text;
    return (React.createElement(React.Fragment, null, text && (React.createElement("li", { className: "publication-category-li text-p text-teal" }, text))));
};
export default PublicationListItemCategory;
